import { createSlice, Dispatch } from '@reduxjs/toolkit';

import { CustomerDataDetail, ICustomerState } from './customer.types'

export const initialCustomerState: ICustomerState = {
	eventsInProgress: 0,
};

const customerSlice = createSlice({
	name: 'customer',
	initialState: initialCustomerState,
	reducers: {
		RESET_CUSTOMER_STATE() {
			return { ...initialCustomerState };
		},
		SET_CUSTOMER_DETAILS(state, action) {
			return {
				...state,
				activeCustomerDetails: action.payload,
			};
		},
		RETRIEVE_CUSTOMER_DETAILS(state, action) {
			return {
				...state,
				eventsInProgress: state.eventsInProgress + 1,
			}
		},
		RETRIEVE_CUSTOMER_DETAILS_SUCCESS(state, action) {
			return {
				...state,
				eventsInProgress: state.eventsInProgress - 1,
				activeCustomerDetails: action.payload.data.customerData,
			}
		},
		RETRIEVE_CUSTOMER_DETAILS_FAIL(state) {
			return {
				...state,
				eventsInProgress: state.eventsInProgress - 1,
			}
		},
	},
});

export const {
	RESET_CUSTOMER_STATE,
	SET_CUSTOMER_DETAILS,
	RETRIEVE_CUSTOMER_DETAILS,
	RETRIEVE_CUSTOMER_DETAILS_SUCCESS,
	RETRIEVE_CUSTOMER_DETAILS_FAIL,
} = customerSlice.actions;

/** Reset state */
export const resetCustomerState = () => async (dispatch: Dispatch) => {
	await dispatch(RESET_CUSTOMER_STATE());
};

/** Set customer details */
export const updateCustomerDetails =
	(customerDetails: CustomerDataDetail[]) => async (dispatch: Dispatch) => {
		await dispatch(SET_CUSTOMER_DETAILS(customerDetails));
	};

/**
 * Retrieve tokenised customer data for the given merchant.
 *
 * @param merchantId - The merchant whose link is being used.
 * @param token - The customer data token.
 */
export const retrieveCustomerDetails =
	(merchantId: string, token: string) => async (dispatch: Dispatch) => {
		const response = await dispatch(
			RETRIEVE_CUSTOMER_DETAILS({
				request: {
					method: 'GET',
					url: `1/public/merchant/${merchantId}/customer/${token}`,
				},
			}),
		);

		return response.payload?.data?.customerData as CustomerDataDetail[];
	}

export default customerSlice.reducer;
